import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconWarning } from '@xingternal/icons';
import { BodyCopy } from '@xingternal/typography';
import { Styled } from './common.style';
export const FlagError = () => (React.createElement(Styled.ErrorContainer, null,
    React.createElement(Styled.ErrorIconContainer, null,
        React.createElement(IconWarning, { width: 24, height: 24 })),
    React.createElement(BodyCopy, { size: "small", lineHeight: "dense", noMargin: true },
        React.createElement(FormattedMessage, { id: "USER_FLAG_ERROR_PARAGRAPH_1" }),
        " ",
        React.createElement("br", null),
        React.createElement(FormattedMessage, { id: "USER_FLAG_ERROR_PARAGRAPH_2" }))));
//# sourceMappingURL=flag-error.js.map